<div class="table-container">
  <div class="data-card">
    <div class="table-wrapper">
      <table mat-table [dataSource]="dataSource" matSort>

        <!-- Agency/Customer Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Agency/Customer </th>
          <td mat-cell *matCellDef="let row"> {{row.description}} </td>
        </ng-container>

        <!-- Commercial Offices Column -->
        <ng-container matColumnDef="office">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Commercial Offices </th>
          <td mat-cell *matCellDef="let row"> {{row.offices | objectList}} </td>
        </ng-container>

        <!-- External ID Column -->
        <ng-container matColumnDef="externalId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> External ID </th>
          <td mat-cell *matCellDef="let row"> {{row.externalId}} </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let row">
            <div class="actions">
              <button matButton class="act-btn" (click)="onEditAgency(row)" matTooltip="Edit Agency">
                <i class="fa-solid fa-pen"></i>
              </button>
              <button matButton class="act-btn danger" (click)="onDeleteAgency(row)" matTooltip="Delete Agency">
                <i class="fa-regular fa-trash-can"></i>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <mat-paginator
      [pageSizeOptions]="[10, 25, 50, 100]"
      showFirstLastButtons
      aria-label="Select page">
    </mat-paginator>
  </div>

  <button class="fab fab-left" (click)="onNewAgency()">
    <i class="fa-solid fa-plus"></i>
    New Agency/Customer
  </button>

</div>
